import React, { useState, useEffect, useMemo } from 'react';
import { 
  Search, User, ShieldCheck, Download, AlertCircle, 
  Briefcase, DollarSign, GraduationCap, FilePlus, ChevronRight, Eye, Printer, Mail
} from 'lucide-react';
import jsPDF from 'jspdf';

import logoEmpresa from '../../../assets/logo.png'
import firmaHR from '../../../assets/firma-DIRECTOR TALENTO HUMANO Y SST.png';

const urlToBase64 = async (url) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error al convertir imagen:", error);
    return null;
  }
};

const NumeroALetras = (num) => {
  const unidades = ["", "UN", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE"];
  const decenas = ["DIECI", "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISEIS", "DIECISIETE", "DIECIOCHO", "DIECINUEVE", "VEINTE", "TREINTA", "CUARENTA", "CINCUENTA", "SESENTA", "SETENTA", "OCHENTA", "NOVENTA"];
  const centenas = ["", "CIENTO", "DOSCIENTOS", "TRESCIENTOS", "CUATROCIENTOS", "QUINIENTOS", "SEISCIENTOS", "SETECIENTOS", "OCHOCIENTOS", "NOVECIENTOS"];

  const convertirGrupo = (n) => {
    let output = "";
    if (n === 100) return "CIEN ";
    if (n > 99) { output += centenas[Math.floor(n / 100)] + " "; n %= 100; }
    if (n > 9 && n < 20) { output += decenas[n - 9] + " "; return output; }
    if (n === 20) { output += "VEINTE "; return output; }
    if (n > 20 && n < 30) { output += "VEINTI" + unidades[n % 10] + " "; return output; }
    if (n >= 30) { output += decenas[Math.floor(n / 10) + 8] + " "; n %= 10; if (n > 0) output += "Y "; }
    if (n > 0) { output += unidades[n] + " "; }
    return output;
  };

  if (num === 0) return "CERO PESOS";
  let letras = "";
  if (num >= 1000000) {
    const millones = Math.floor(num / 1000000);
    letras += millones === 1 ? "UN MILLÓN " : convertirGrupo(millones) + "MILLONES ";
    num %= 1000000;
  }
  if (num >= 1000) {
    const miles = Math.floor(num / 1000);
    letras += miles === 1 ? "MIL " : convertirGrupo(miles) + "MIL ";
    num %= 1000;
  }
  if (num > 0) {
    letras += convertirGrupo(num);
  }
  return letras.trim() + " PESOS";
};

const formatearFechaTexto = (fechaString) => {
  if (!fechaString || fechaString === '0000-00-00' || String(fechaString).toUpperCase() === 'NULL') return "";
  const meses = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"];
  const date = new Date(fechaString);
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  const localDate = new Date(date.getTime() + userTimezoneOffset);
  
  const dia = localDate.getDate();
  const mes = meses[localDate.getMonth()];
  const anio = localDate.getFullYear();
  return `${dia} DE ${mes} DE ${anio}`;
};

const formatearDiaMesAnio = () => {
  const meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
  const date = new Date();
  const dia = String(date.getDate()).padStart(2, '0');
  const mes = meses[date.getMonth()];
  const anio = date.getFullYear();
  return { dia, mes, anio };
};

const verificarSiEsRetirado = (datos) => {
  if (!datos) return false;
  const fecha = datos.empl_fecret || datos.fecha_retiro;
  const tieneFecha = fecha !== undefined && 
                     fecha !== null && 
                     fecha !== '0000-00-00' && 
                     fecha !== '0000-00-00 00:00:00' && 
                     String(fecha).trim() !== '' && 
                     String(fecha).trim().toUpperCase() !== 'NULL';
  return Boolean(tieneFecha);
};

const CertificadosModule = ({ onBack }) => {
  const [cedulaBuscar, setCedulaBuscar] = useState('');
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const [categoriaActiva, setCategoriaActiva] = useState('laborales');

  const [modalAbierto, setModalAbierto] = useState(false);
  const [certificadoSeleccionado, setCertificadoSeleccionado] = useState(null);

  const [historialEvals, setHistorialEvals] = useState([]);
  const [evaluacionIdSeleccionada, setEvaluacionIdSeleccionada] = useState("");
  const [cargandoHistorial, setCargandoHistorial] = useState(false);

  const usuarioLogueado = useMemo(() => {
    const userStr = localStorage.getItem('usuario');
    return userStr ? JSON.parse(userStr) : null;
  }, []);

  // 🔒 1. EXTRACCIÓN ABAC IDÉNTICA A DOCUMENTOS LEGALES
  const permisosABAC = useMemo(() => {
    try {
      const parsed = typeof usuarioLogueado?.permisos_avanzados === 'string' 
        ? JSON.parse(usuarioLogueado.permisos_avanzados) 
        : (usuarioLogueado?.permisos_avanzados || {});
      // El truco de Documentos Legales para mapear la BD correctamente:
      return parsed.micros || parsed; 
    } catch (e) { 
      return {}; 
    }
  }, [usuarioLogueado]);

  // 🔒 2. VALIDACIÓN DE SUPERADMIN IDÉNTICA A DOCUMENTOS LEGALES (Evita falsos positivos con otros cargos)
const esAdminGlobal = String(usuarioLogueado?.cargo || "").toUpperCase().includes("SUPER");
  // 🔒 3. VERIFICADOR ESTRICTO POR LLAVE ABAC
  const checkPermiso = (nombreSubmodulo) => {
    if (esAdminGlobal) return true;
    return permisosABAC[nombreSubmodulo] !== undefined;
  };

  const tienePermisoBusqueda = esAdminGlobal || checkPermiso('Control de Gestión Humana');

  const llavesModulo = [
    'Control de Gestión Humana', 'Certificado de Vinculación', 'Certificado de Retiro', 
    'Evaluación de Desempeño', 'Desprendibles de Nómina', 'Ingresos y Retenciones', 
    'Certificado de Cesantías', 'Capacitaciones Internas', 'Certificado de Vacaciones', 
    'Seguridad Social'
  ];
  const tieneAlgunPermiso = esAdminGlobal || llavesModulo.some(k => checkPermiso(k));

  useEffect(() => {
    if (usuarioLogueado) {
      if (!tienePermisoBusqueda) {
        setCedulaBuscar(usuarioLogueado.documento || ''); 
      } else {
        setCedulaBuscar(''); 
      }
    }
  }, [usuarioLogueado, tienePermisoBusqueda]);

  const categorias = [
    { id: 'laborales', nombre: 'Laborales', icono: <Briefcase className="w-4 h-4" /> },
    { id: 'financieros', nombre: 'Financieros', icono: <DollarSign className="w-4 h-4" /> },
    { id: 'formacion', nombre: 'Formación', icono: <GraduationCap className="w-4 h-4" /> },
    { id: 'otros', nombre: 'Otros', icono: <FilePlus className="w-4 h-4" /> },
  ];

  const generarCertificadoLaboralPDF = (datos, logoB64, firmaB64, tipoDocumento) => {
    const doc = new jsPDF();
    
    const salarioNumerico = Number(datos.empl_salario || 0);
    const salarioFormateado = salarioNumerico.toLocaleString('es-CO');
    const salarioLetras = NumeroALetras(salarioNumerico);
    const fechaIngresoTexto = formatearFechaTexto(datos.empl_fecing);
    const { dia, mes, anio } = formatearDiaMesAnio();

    const generoBD = String(datos.terc_sexo || datos.sexo || datos.genero || 'M').trim().toUpperCase();
    const esFemenino = generoBD === 'F' || generoBD === 'FEMENINO';

    const prefijo = esFemenino ? "La señora" : "El señor";
    const identificacion = esFemenino ? "identificada" : "identificado";
    const trabajador = esFemenino ? "La trabajadora" : "El trabajador";
    const interesado = esFemenino ? "de la interesada" : "del interesado";

    const isRetirado = verificarSiEsRetirado(datos);
    const fechaRetiroTexto = isRetirado ? formatearFechaTexto(datos.empl_fecret || datos.fecha_retiro) : "";

    if (logoB64) {
      doc.addImage(logoB64, 'PNG', 75, 15, 60, 25); 
    }
    
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text("LUIS ALEXANDER DIAZ ROMERO", 105, 45, { align: "center" });
    doc.text("NIT. 80851613-7", 105, 50, { align: "center" });
    
    doc.setFontSize(12);
    doc.text("LA DIRECCION DE TALENTO HUMANO", 105, 65, { align: "center" });
    doc.text("CERTIFICA", 105, 80, { align: "center" });
    
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    
    let parrafo1 = "";
    if (isRetirado && fechaRetiroTexto) {
      parrafo1 = `${prefijo} ${datos.terc_nom}, ${identificacion} con cédula de ciudadanía No ${datos.terc_nit} laboró en nuestra compañía desde el ${fechaIngresoTexto} hasta el ${fechaRetiroTexto}, mediante CONTRATO A TÉRMINO INDEFINIDO.`;
    } else {
      parrafo1 = `${prefijo} ${datos.terc_nom}, ${identificacion} con cédula de ciudadanía No ${datos.terc_nit} labora en nuestra compañía desde el ${fechaIngresoTexto}, mediante CONTRATO A TÉRMINO INDEFINIDO.`;
    }

    const splitP1 = doc.splitTextToSize(parrafo1, 170);
    doc.text(splitP1, 20, 95);
    
    let cursorY = 95 + (splitP1.length * 6); 
    
    const verboCargo = isRetirado ? "Se desempeñó" : "Se desempeña";
    const parrafo2 = `${verboCargo} en el cargo de ${datos.empl_cargo}.`;
    doc.text(parrafo2, 20, cursorY + 5);
    
    const verboSalario = isRetirado ? "devengaba" : "devenga";
    const parrafo3 = `${trabajador} ${verboSalario} un salario mensual de $${salarioFormateado} (${salarioLetras} M/CTE).`;
    const splitP3 = doc.splitTextToSize(parrafo3, 170);
    doc.text(splitP3, 20, cursorY + 15);
    
    cursorY = cursorY + 15 + (splitP3.length * 6);
    
    const parrafo4 = `La presente certificación se expide a solicitud ${interesado} para los fines que estime convenientes.`;
    const splitP4 = doc.splitTextToSize(parrafo4, 170);
    doc.text(splitP4, 20, cursorY + 5);
    
    cursorY = cursorY + 5 + (splitP4.length * 6);
    
    const parrafo5 = `Dada en Fusagasugá, a los (${dia}) días del mes de ${mes} del ${anio}`;
    doc.text(parrafo5, 20, cursorY + 10);
    
    doc.text("Cordialmente", 20, cursorY + 25);
    
    const firmaY = cursorY + 20;
    if (firmaB64) {
      doc.addImage(firmaB64, 'PNG', 85, firmaY, 40, 30); 
    }
    
    const nombreFirmaY = firmaY + 35;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text("ANGELICA MARIA PULIDO RIVERA", 105, nombreFirmaY, { align: "center" });
    doc.setFont("helvetica", "normal");
    doc.text("Directora Talento Humano", 105, nombreFirmaY + 5, { align: "center" });
    
    const elaboroY = nombreFirmaY + 20;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.text("Elaboro:", 20, elaboroY);
    doc.text("PAULA ANDREA TORRES FORERO", 20, elaboroY + 5);
    doc.line(20, elaboroY + 6, 72, elaboroY + 6);
    doc.setFont("helvetica", "normal");
    doc.text("Auxiliar de talento humano", 20, elaboroY + 10);
    
    const footerY = 265;
    doc.setDrawColor(0, 153, 51); 
    doc.setLineWidth(1.5);
    doc.line(20, footerY - 5, 105, footerY - 5);
    doc.setDrawColor(255, 204, 0); 
    doc.line(105, footerY - 5, 190, footerY - 5);
    
    doc.setFontSize(10);
    doc.text("Correo electrónico: ", 90, footerY, { align: "right" });
    doc.setTextColor(0, 0, 255);
    doc.text("rrhhgransurtidor@gmail.com", 91, footerY, { align: "left" });
    doc.setTextColor(0, 0, 0);
    doc.text("Teléfono: 3124808094", 105, footerY + 5, { align: "center" });
    doc.text("Dirección: Carrera 6 # 19b-37 segundo piso Balmoral- Fusagasugá", 105, footerY + 10, { align: "center" });
    
    doc.save(`Certificado_Laboral_${datos.terc_nit}.pdf`);
  };

  const generarCertificadoEvaluacionPDF = (datosEmp, datosEval, logoB64) => {
    const doc = new jsPDF();
    
    const corregirTexto = (texto) => {
      if (!texto) return "";
      return String(texto)
        .replace(/Ã‘/g, 'Ñ').replace(/Ã±/g, 'Ñ').replace(/ÿÿ/g, 'Ñ')
        .replace(/Ã/g, 'Í')
        .toUpperCase();
    };

    const nombreColaborador = corregirTexto(datosEmp.terc_nom);
    const cargoColaborador = corregirTexto(datosEmp.empl_cargo || 'No registrado');

    if (logoB64) doc.addImage(logoB64, 'PNG', 75, 12, 60, 25); 
    
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.setTextColor(15, 23, 42); 
    doc.text("REPORTE OFICIAL DE EVALUACIÓN DE DESEMPEÑO", 105, 48, { align: "center" });
    
    doc.setDrawColor(226, 232, 240); 
    doc.setFillColor(248, 250, 252); 
    doc.roundedRect(15, 55, 180, 32, 3, 3, "FD"); 
    
    doc.setFontSize(9);
    doc.setTextColor(100, 116, 139);
    doc.text("1. INFORMACIÓN DEL COLABORADOR", 20, 62);
    
    doc.setTextColor(15, 23, 42);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("Nombre Completo:", 20, 72);
    doc.setFont("helvetica", "bold");
    doc.text(nombreColaborador, 55, 72);
    
    doc.setFont("helvetica", "normal");
    doc.text("Documento:", 140, 72);
    doc.setFont("helvetica", "bold");
    doc.text(String(datosEmp.terc_nit), 163, 72);
    
    doc.setFont("helvetica", "normal");
    doc.text("Cargo Actual:", 20, 81);
    doc.setFont("helvetica", "bold");
    doc.text(cargoColaborador, 55, 81);

    doc.roundedRect(15, 95, 180, 48, 3, 3, "S"); 
    
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(100, 116, 139);
    doc.text("2. RESULTADOS DE LA EVALUACIÓN", 20, 102);
    
    const fechaFormat = formatearFechaTexto(datosEval.fecha_evaluacion || datosEval.fecha || new Date().toISOString());
    
    doc.setTextColor(15, 23, 42);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("Fecha de Aplicación:", 20, 113);
    doc.setFont("helvetica", "bold");
    doc.text(fechaFormat, 60, 113);
    
    const puntaje = Number(datosEval.puntaje_total || datosEval.puntaje || 0).toFixed(2);
    let nivel = 'MEJORABLE';
    let colorRGB = [220, 38, 38]; 
    
    if (puntaje >= 90) { 
      nivel = 'EXCELENTE'; 
      colorRGB = [22, 163, 74]; 
    } else if (puntaje >= 70) { 
      nivel = 'BUENO - CON COMPROMISOS'; 
      colorRGB = [202, 138, 4]; 
    }
    
    doc.setFont("helvetica", "normal");
    doc.text("Puntaje Global:", 20, 125);
    
    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(colorRGB[0], colorRGB[1], colorRGB[2]); 
    doc.text(`${puntaje}%`, 60, 126);
    
    doc.setFontSize(10);
    doc.setTextColor(15, 23, 42);
    doc.setFont("helvetica", "normal");
    doc.text("Nivel Alcanzado:", 110, 125); 
    
    doc.setFont("helvetica", "bold");
    doc.setTextColor(colorRGB[0], colorRGB[1], colorRGB[2]);
    if (nivel.length > 15) doc.setFontSize(9); 
    doc.text(nivel, 190, 125, { align: "right" });

    doc.setTextColor(15, 23, 42);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    const conceptoBackend = String(datosEval.concepto || "Generado por Sistema").toUpperCase();
    doc.text("Dictamen Final:", 20, 137);
    doc.setFont("helvetica", "bold");
    doc.text(conceptoBackend, 60, 137);

    doc.roundedRect(15, 150, 180, 35, 3, 3, "S");
    doc.setFontSize(9);
    doc.setTextColor(100, 116, 139);
    doc.text("3. NOTA DE DESARROLLO", 20, 157);
    
    doc.setTextColor(50, 50, 50);
    doc.setFont("helvetica", "italic");
    doc.setFontSize(9);
    const obsText = "Este puntaje refleja el consolidado de las competencias evaluadas: Valores Organizacionales, Conocimiento del Cargo, Conducta, Relaciones Interpersonales y Desempeño General. Se insta al colaborador a revisar los planes de acción propuestos por su jefatura inmediata en su panel de usuario.";
    const splitObs = doc.splitTextToSize(obsText, 170);
    doc.text(splitObs, 20, 166);

    let firmaEvalB64 = null;
    let firmaEmpB64 = null;
    let nombreEvaluador = "Jefatura Inmediata";
    let nombreEvaluado = nombreColaborador;

    if (datosEval.firmas && Array.isArray(datosEval.firmas)) {
        const fEv = datosEval.firmas.find(f => f.tipo_firma && String(f.tipo_firma).toLowerCase().trim() === 'evaluador');
        if (fEv && fEv.firma) {
            firmaEvalB64 = fEv.firma.includes('data:image') ? fEv.firma : `data:image/png;base64,${fEv.firma}`;
            if (fEv.firmante) nombreEvaluador = corregirTexto(fEv.firmante);
        }
        
        const fEmp = datosEval.firmas.find(f => !f.tipo_firma || String(f.tipo_firma).toLowerCase().trim() !== 'evaluador');
        if (fEmp && fEmp.firma) {
            firmaEmpB64 = fEmp.firma.includes('data:image') ? fEmp.firma : `data:image/png;base64,${fEmp.firma}`;
            if (fEmp.firmante) nombreEvaluado = corregirTexto(fEmp.firmante);
        }
    }

    try {
        if (firmaEvalB64) doc.addImage(firmaEvalB64, 'PNG', 40, 205, 40, 28); 
        if (firmaEmpB64) doc.addImage(firmaEmpB64, 'PNG', 130, 205, 40, 28); 
    } catch (err) {
        console.error("No se pudieron renderizar las firmas en el PDF", err);
    }

    doc.setDrawColor(150, 150, 150);
    doc.setLineWidth(0.5);
    doc.line(30, 235, 90, 235);
    doc.line(120, 235, 180, 235);
    
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.setTextColor(15, 23, 42);
    
    const splitEvalNombre = doc.splitTextToSize(nombreEvaluador, 60);
    doc.text(splitEvalNombre, 60, 240, { align: "center" });
    
    const splitEmpNombre = doc.splitTextToSize(nombreEvaluado, 60);
    doc.text(splitEmpNombre, 150, 240, { align: "center" });
    
    doc.setFont("helvetica", "normal");
    doc.setTextColor(100, 116, 139);
    
    let ccEvaluador = "________________";
    if (datosEval.documento_evaluador) ccEvaluador = datosEval.documento_evaluador;
    else if (datosEval.cc_evaluador) ccEvaluador = datosEval.cc_evaluador;
    else if (datosEval.evaluador && /^\d+$/.test(String(datosEval.evaluador).trim())) ccEvaluador = datosEval.evaluador;

    doc.text(`C.C. ${ccEvaluador}`, 60, 248, { align: "center" });
    doc.text(`C.C. ${datosEmp.terc_nit}`, 150, 248, { align: "center" });

    const footerY = 275;
    doc.setDrawColor(0, 153, 51); 
    doc.setLineWidth(1.5);
    doc.line(15, footerY - 5, 105, footerY - 5);
    doc.setDrawColor(255, 204, 0); 
    doc.line(105, footerY - 5, 195, footerY - 5);
    
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text("El Gran Surtidor - Documento generado automáticamente por el Sistema de Gestión Humana", 105, footerY + 2, { align: "center" });
    
    doc.save(`Reporte_Evaluacion_${datosEmp.terc_nit}.pdf`);
  };

  const descargarCertificado = async (tipoDocumento) => {
    const documentoFinal = tienePermisoBusqueda ? cedulaBuscar : usuarioLogueado.documento;

    if (!documentoFinal) {
      setError(tienePermisoBusqueda ? "Debes ingresar la cédula a buscar." : "No se pudo verificar tu número de documento.");
      setTimeout(() => setError(''), 4000);
      return;
    }
    
    if (tipoDocumento !== 'laboral_vinculacion' && tipoDocumento !== 'laboral_retiro' && tipoDocumento !== 'laboral_desempeno') {
      setError(`El documento solicitado estará disponible en la próxima actualización.`);
      setTimeout(() => setError(''), 4000);
      return;
    }

    setCargando(true);
    setError('');
    
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/empleados/certificado/${documentoFinal}`);
      const result = await res.json();
      
      if (result.success) {
        const logoB64 = await urlToBase64(logoEmpresa);
        const firmaB64 = await urlToBase64(firmaHR);
        const isRetirado = verificarSiEsRetirado(result.data);

        if (tipoDocumento === 'laboral_vinculacion') {
          if (isRetirado) {
            setError("El empleado se encuentra retirado. Debe descargar el Certificado de Retiro.");
          } else {
            generarCertificadoLaboralPDF(result.data, logoB64, firmaB64, tipoDocumento);
          }
        } 
        else if (tipoDocumento === 'laboral_retiro') {
          if (!isRetirado) {
            setError("El empleado se encuentra activo. Debe descargar el Certificado de Vinculación.");
          } else {
            generarCertificadoLaboralPDF(result.data, logoB64, firmaB64, tipoDocumento);
          }
        }
        else if (tipoDocumento === 'laboral_desempeno') {
          try {
            const resEval = await fetch(`${process.env.REACT_APP_API_URL}/api/evaluaciones/historial/${documentoFinal}`);
            const resultEval = await resEval.json();
            
            if (resultEval.success && resultEval.data && resultEval.data.length > 0) {
              const evalToDownload = evaluacionIdSeleccionada 
                ? resultEval.data.find(e => String(e.id) === String(evaluacionIdSeleccionada)) 
                : resultEval.data[0];
                
              if (evalToDownload) {
                generarCertificadoEvaluacionPDF(result.data, evalToDownload, logoB64);
              } else {
                setError("No se encontró la evaluación especificada.");
              }
            } else {
              setError("No se encontraron evaluaciones de desempeño registradas para este empleado.");
            }
          } catch (e) {
            setError("Error al consultar el historial de evaluaciones.");
          }
        }
      } else {
        setError(result.message || "No se pudo encontrar información de este empleado.");
      }
    } catch (err) {
      setError("Error de conexión con el servidor.");
    } finally {
      setCargando(false);
      if (error) setTimeout(() => setError(''), 5000);
    }
  };

  const abrirModalDetalle = async (cert) => {
    setCertificadoSeleccionado(cert);
    setEvaluacionIdSeleccionada("");
    setHistorialEvals([]);
    
    const docAconsultar = tienePermisoBusqueda ? cedulaBuscar : usuarioLogueado.documento;

    if (cert.id === 'laboral_desempeno' && docAconsultar) {
      setCargandoHistorial(true);
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/evaluaciones/historial/${docAconsultar}`);
        const data = await res.json();
        if (data.success && data.data) {
          setHistorialEvals(data.data);
          if(data.data.length > 0) setEvaluacionIdSeleccionada(data.data[0].id); 
        }
      } catch (error) {
        console.error("Error cargando historial de evaluaciones");
      } finally {
        setCargandoHistorial(false);
      }
    }
    
    setModalAbierto(true);
  };

  const renderizarTarjetas = () => {
    const certificados = {
      laborales: [
        { id: 'laboral_vinculacion', titulo: 'Certificado de Vinculación', desc: 'Constancia oficial de relación laboral activa.', activo: checkPermiso('Certificado de Vinculación') },
        { id: 'laboral_retiro', titulo: 'Certificado de Retiro', desc: 'Constancia oficial de fin de contrato.', activo: checkPermiso('Certificado de Retiro') },
        { id: 'laboral_desempeno', titulo: 'Evaluación de Desempeño', desc: 'Resultados de tus últimas evaluaciones.', activo: checkPermiso('Evaluación de Desempeño') },
      ],
      financieros: [
        { id: 'fin_nomina', titulo: 'Desprendibles de Nómina', desc: 'Detalle de pagos, deducciones y aportes.', activo: checkPermiso('Desprendibles de Nómina') },
        { id: 'fin_retenciones', titulo: 'Ingresos y Retenciones', desc: 'Usado para trámites tributarios o bancarios.', activo: checkPermiso('Ingresos y Retenciones') },
        { id: 'fin_cesantias', titulo: 'Certificado de Cesantías', desc: 'Constancia de consignación anual.', activo: checkPermiso('Certificado de Cesantías') },
      ],
      formacion: [
        { id: 'form_capacitacion', titulo: 'Capacitaciones Internas', desc: 'Cursos, talleres o entrenamientos realizados.', activo: checkPermiso('Capacitaciones Internas') },
      ],
      otros: [
        { id: 'otro_vacaciones', titulo: 'Certificado de Vacaciones', desc: 'Días disfrutados o pendientes.', activo: checkPermiso('Certificado de Vacaciones') },
        { id: 'otro_seguridad', titulo: 'Seguridad Social', desc: 'Afiliación a EPS, Pensión y ARL.', activo: checkPermiso('Seguridad Social') },
      ]
    };

    return certificados[categoriaActiva].map((cert) => (
      <div key={cert.id} className={`bg-white/5 border border-white/10 rounded-2xl p-3.5 h-[115px] flex flex-col justify-between transition-all ${cert.activo ? 'hover:bg-white/10 shadow-lg' : 'opacity-60 grayscale'}`}>
        <div>
          <h4 className="text-white font-black text-sm mb-0.5">{cert.titulo}</h4>
          <p className="text-white/60 text-[11px] font-medium leading-tight">{cert.desc}</p>
        </div>
        
        {tienePermisoBusqueda ? (
          <button 
            onClick={() => abrirModalDetalle(cert)}
            disabled={!cert.activo}
            className={`mt-auto py-1 px-3 rounded-lg font-bold text-[10px] uppercase tracking-wide flex items-center justify-center gap-1.5 transition-colors ${
              cert.activo 
                ? 'bg-indigo-600 hover:bg-indigo-500 text-white cursor-pointer shadow-md' 
                : 'bg-white/10 text-white/40 cursor-not-allowed'
            }`}
          >
            {cert.activo ? <><Eye className="w-3 h-3" /> Ver Detalle</> : 'Restringido'}
          </button>
        ) : (
          <button 
            onClick={() => descargarCertificado(cert.id)}
            disabled={!cert.activo || cargando}
            className={`mt-auto py-1 px-3 rounded-lg font-bold text-[10px] uppercase tracking-wide flex items-center justify-center gap-1.5 transition-colors ${
              cert.activo 
                ? 'bg-emerald-600 hover:bg-emerald-500 text-white cursor-pointer shadow-md' 
                : 'bg-white/10 text-white/40 cursor-not-allowed'
            }`}
          >
            {cargando && cert.activo ? 'Generando...' : cert.activo ? <><Download className="w-3 h-3" /> Descargar</> : 'Restringido'}
          </button>
        )}
      </div>
    ));
  };

  if (!usuarioLogueado) return null;

  if (!tieneAlgunPermiso) {
    return (
      <div className="w-full min-h-screen py-8 px-4 flex flex-col items-center animate-fade-in">
        <div className="bg-white/10 backdrop-blur-3xl rounded-[34px] shadow-[0_25px_70px_rgba(0,0,0,0.15)] p-10 max-w-4xl w-full mx-auto border border-white/35 text-center animate-fade-in relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500"></div>
          <span className="text-6xl block mb-6">🛡️</span>
          <h2 className="text-2xl font-black text-white mb-2">Acceso Restringido</h2>
          <p className="text-sm text-slate-200 mb-8 font-medium">No cuentas con privilegios asignados en la matriz ABAC para visualizar el Módulo de Certificados y Documentos.</p>
          <button onClick={onBack} className="px-6 py-2.5 bg-indigo-600 hover:bg-indigo-500 text-white font-bold rounded-full transition shadow-md cursor-pointer">
            Volver al Menú Principal
          </button>
        </div>
      </div>
    );
  }

  const sinDatosDisponibles = certificadoSeleccionado?.id === 'laboral_desempeno' && historialEvals.length === 0 && !cargandoHistorial;

  return (
    <div className="w-full min-h-screen py-8 px-4 flex flex-col items-center animate-fade-in">
      <div className="w-full max-w-5xl bg-white/10 backdrop-blur-3xl border border-white/35 shadow-2xl rounded-[34px] p-6 sm:p-10 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500"></div>

        <div className="flex flex-col sm:flex-row items-center gap-4 mb-8 border-b border-white/20 pb-6">
          {onBack && (
            <button onClick={onBack} className="w-12 h-12 flex-none bg-white/20 hover:bg-white/30 text-white flex items-center justify-center rounded-full transition-all shadow-md border border-white/30 cursor-pointer self-start sm:self-center">
              <ChevronRight className="w-6 h-6 rotate-180" />
            </button>
          )}
          <div className="flex-1 text-center sm:text-left">
            <h2 className="text-2xl sm:text-3xl font-black text-white tracking-tight drop-shadow-md">Centro de Documentos</h2>
            <p className="text-sm font-bold text-slate-200 mt-1">Descarga oficial de certificados y comprobantes</p>
          </div>
        </div>

        {error && (
          <div className="mb-6 bg-rose-500/40 border border-rose-400/50 text-white p-4 rounded-xl flex items-center gap-3 font-bold text-sm animate-fade-in">
            <AlertCircle className="w-5 h-5 flex-none" /> {error}
          </div>
        )}

        {tienePermisoBusqueda && (
          <div className="mb-8 bg-black/30 border border-indigo-500/30 rounded-2xl p-5 sm:p-6 shadow-inner">
            <div className="flex items-center gap-2 mb-4">
              <ShieldCheck className="w-6 h-6 text-emerald-400" />
              <h3 className="text-white font-black text-lg">Control de Gestión Humana</h3>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <div className="relative flex-1">
                <Search className="w-5 h-5 text-gray-500 absolute left-4 top-3.5" />
                <input 
                  type="text" 
                  placeholder="Ingresa la cédula del colaborador..."
                  value={cedulaBuscar}
                  onChange={(e) => setCedulaBuscar(e.target.value)}
                  className="w-full pl-11 pr-4 py-3 bg-white border border-gray-300 rounded-xl text-gray-900 font-extrabold focus:outline-none focus:ring-2 focus:ring-indigo-500 placeholder-gray-400 shadow-inner"
                />
              </div>
            </div>
          </div>
        )}

        {!tienePermisoBusqueda && (
          <div className="mb-8 bg-indigo-900/40 border border-indigo-500/30 rounded-2xl p-5 shadow-inner flex items-center gap-4">
            <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center flex-none">
              <User className="w-6 h-6 text-indigo-200" />
            </div>
            <div>
              <h3 className="text-white font-black text-lg leading-tight">Hola, {usuarioLogueado.nombres ? usuarioLogueado.nombres.split(' ')[0] : 'Colaborador'}</h3>
              <p className="text-indigo-200 text-xs font-medium">Tus documentos están listos para descarga directa.</p>
            </div>
          </div>
        )}

        <div className="flex overflow-x-auto gap-2 mb-6 pb-2 custom-scrollbar">
          {categorias.map(cat => (
            <button
              key={cat.id}
              onClick={() => setCategoriaActiva(cat.id)}
              className={`flex items-center gap-2 px-5 py-3 rounded-xl font-bold text-sm transition-all whitespace-nowrap cursor-pointer ${
                categoriaActiva === cat.id 
                  ? 'bg-white text-indigo-900 shadow-md' 
                  : 'bg-white/10 text-white hover:bg-white/20'
              }`}
            >
              {cat.icono}
              {cat.nombre}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {renderizarTarjetas()}
        </div>

      </div>

      {modalAbierto && certificadoSeleccionado && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md animate-fade-in">
          <div className="relative w-full max-w-3xl rounded-[32px] bg-white/10 backdrop-blur-[45px] border border-white/20 shadow-[0_25px_70px_rgba(0,0,0,0.5)] flex flex-col md:flex-row overflow-hidden animate-scale-in">
            
            <div className="w-full md:w-5/12 bg-black/20 p-8 flex flex-col items-center justify-center border-r border-white/10">
              <div className="w-full max-w-[200px] aspect-[1/1.4] bg-white rounded-lg shadow-[0_10px_30px_rgba(0,0,0,0.3)] flex flex-col items-center justify-start pt-8 px-4 relative overflow-hidden">
                 <div className="w-12 h-12 bg-indigo-50 rounded-full flex items-center justify-center mb-4">
                    <FilePlus className="w-6 h-6 text-indigo-600" />
                 </div>
                 <div className="w-full h-1.5 bg-gray-200 rounded-full mb-2"></div>
                 <div className="w-3/4 h-1.5 bg-gray-200 rounded-full mb-6"></div>
                 <div className="w-full h-24 bg-gray-50 rounded-md border border-gray-100 flex flex-col gap-1.5 p-2">
                    <div className="w-full h-1 bg-gray-200 rounded-full"></div>
                    <div className="w-5/6 h-1 bg-gray-200 rounded-full"></div>
                    <div className="w-4/6 h-1 bg-gray-200 rounded-full"></div>
                 </div>
                 <div className="absolute top-3 right-3 px-2 py-0.5 bg-emerald-100 border border-emerald-300 text-emerald-700 text-[8px] font-black rounded-full uppercase">
                    VIGENTE
                 </div>
              </div>
            </div>

            <div className="w-full md:w-7/12 p-8 flex flex-col">
              <div className="flex justify-between items-start mb-6">
                <div>
                  <h3 className="text-2xl font-black text-white leading-tight mb-1">{certificadoSeleccionado.titulo}</h3>
                  <p className="text-xs text-indigo-200 font-medium">{certificadoSeleccionado.desc}</p>
                </div>
                <button onClick={() => setModalAbierto(false)} className="text-white/50 hover:text-white transition cursor-pointer">✕</button>
              </div>

              {certificadoSeleccionado.id === 'laboral_desempeno' && (
                <div className="mb-4">
                  <label className="block text-[10px] text-white/70 font-bold uppercase tracking-wider mb-2">Seleccione el periodo a descargar:</label>
                  {cargandoHistorial ? (
                    <div className="text-white/50 text-xs font-bold animate-pulse">Cargando historial de evaluaciones...</div>
                  ) : historialEvals.length > 0 ? (
                    <select 
                      value={evaluacionIdSeleccionada}
                      onChange={(e) => setEvaluacionIdSeleccionada(e.target.value)}
                      className="w-full px-4 py-2.5 bg-black/30 border border-white/20 text-white rounded-xl text-xs font-bold focus:outline-none focus:border-indigo-400 cursor-pointer"
                    >
                      {historialEvals.map(ev => (
                        <option key={ev.id} value={ev.id} className="text-black">
                          {formatearFechaTexto(ev.fecha_evaluacion || ev.fecha)} - Puntaje: {ev.puntaje_total || ev.puntaje}%
                        </option>
                      ))}
                    </select>
                  ) : (
                    <div className="text-amber-400 text-xs font-bold bg-amber-500/10 p-2 rounded border border-amber-500/20">
                      No se encontraron registros previos de evaluación.
                    </div>
                  )}
                </div>
              )}

              <div className="bg-white/5 rounded-2xl p-5 mb-6 border border-white/10 shadow-inner">
                <div className="flex justify-between items-center mb-3 pb-3 border-b border-white/10">
                  <span className="text-xs text-white/60 font-bold uppercase tracking-wider">Colaborador:</span>
                  <span className="text-sm text-white font-black text-right">
                    {tienePermisoBusqueda && cedulaBuscar ? "Consultado" : `${usuarioLogueado.nombres ? usuarioLogueado.nombres.split(' ')[0] : ''} ${usuarioLogueado.apellidos ? usuarioLogueado.apellidos.split(' ')[0] : ''}`}
                  </span>
                </div>
                <div className="flex justify-between items-center mb-3 pb-3 border-b border-white/10">
                  <span className="text-xs text-white/60 font-bold uppercase tracking-wider">Documento:</span>
                  <span className="text-sm text-white font-mono font-bold">
                    {tienePermisoBusqueda && cedulaBuscar ? cedulaBuscar : usuarioLogueado.documento}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-xs text-white/60 font-bold uppercase tracking-wider">Fecha Sistema:</span>
                  <span className="text-xs text-white font-bold">{formatearDiaMesAnio().dia} de {formatearDiaMesAnio().mes}, {formatearDiaMesAnio().anio}</span>
                </div>
              </div>

              <div className="mt-auto space-y-3">
                <button 
                  onClick={() => {
                     setModalAbierto(false);
                     descargarCertificado(certificadoSeleccionado.id);
                  }} 
                  disabled={cargando || sinDatosDisponibles}
                  className={`w-full py-3.5 text-white text-xs font-black uppercase tracking-wider rounded-xl transition flex items-center justify-center gap-2 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed ${sinDatosDisponibles ? 'bg-gray-500' : 'bg-indigo-600 hover:bg-indigo-500 shadow-[0_4px_14px_rgba(79,70,229,0.4)]'}`}
                >
                  <Download className="w-4 h-4" /> {cargando ? "Procesando..." : (sinDatosDisponibles ? "Sin datos para descargar" : "Descargar PDF Oficial")}
                </button>
                <div className="flex gap-3">
                  <button onClick={() => alert("Esta opción estará disponible junto al módulo de impresión directa.")} className="flex-1 py-3 bg-white/10 hover:bg-white/20 text-white text-xs font-bold rounded-xl transition flex items-center justify-center gap-2 cursor-pointer border border-white/20">
                    <Printer className="w-4 h-4" /> Imprimir
                  </button>
                  <button onClick={() => alert("El envío por correo masivo y automatizado llegará en el próximo módulo (Power BI).")} className="flex-1 py-3 bg-white/5 hover:bg-white/10 text-white text-xs font-bold rounded-xl transition flex items-center justify-center gap-2 cursor-pointer border border-white/10">
                    <Mail className="w-4 h-4" /> Enviar Correo
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default CertificadosModule;